import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.7 2.639a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4 0L10 8.407 7.4 5.865c.4-.587.6-1.271.6-1.955C8 1.759 6.2 0 4 0S0 1.759 0 3.91c0 2.15 1.8 3.91 4 3.91.7 0 1.4-.196 2-.587l2.6 2.542L6 12.317c-.6-.391-1.3-.587-2-.587-2.2 0-4 1.76-4 3.91s1.8 3.911 4 3.911 4-1.76 4-3.91c0-.685-.2-1.369-.6-1.955zM2 3.909c0-1.074.9-1.954 2-1.954s2 .88 2 1.955c0 .586-.2.977-.6 1.368s-.8.587-1.4.587c-1.1 0-2-.881-2-1.956m2 13.687c-1.1 0-2-.88-2-1.955s.9-1.955 2-1.955c.6 0 1 .195 1.4.586s.6.782.6 1.369c0 1.075-.9 1.955-2 1.955m9.2-6.061a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l5.5 5.377c.2.196.5.293.7.293s.5-.097.7-.293a.93.93 0 0 0 0-1.368z"
    }, null, -1)
  ]))]))
}
export default { render: render }